import React from 'react';
import type { ReactElement } from 'react';
import { useLoads } from 'react-loads-next';

import sdk from '@medipass/web-sdk';
const Context: any = React.createContext({
  application: {},
});
type Props = {
  children: ReactElement;
};
export function Provider(props: Props) {
  const applicationLoader = useLoads('application', sdk.applications.getSelfApplication, {
    loadPolicy: 'cache-first',
  });
  const application = applicationLoader.response || {}; //eslint-disable-line

  const value = React.useMemo(
    () => ({
      application,
    }),
    [application],
  );
  return <Context.Provider value={value}>{props.children}</Context.Provider>;
}
export const Consumer = Context.Consumer;
